'use strict';

var forceInitRecomm = require('../recommendations');

function initializeEvents() {
  forceInitRecomm.init();
}

exports.init = function () {
  initializeEvents();
};
